"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharedSliceRef = void 0;
const tslib_1 = require("tslib");
const t = (0, tslib_1.__importStar)(require("io-ts"));
const SharedSlice_1 = require("./SharedSlice");
exports.SharedSliceRef = t.exact(t.type({
    type: t.literal(SharedSlice_1.SharedSliceType),
}));
